import { moneyFormatOptions } from "../app.settings.js";
import * as BRUtils from "@brazilian-utils/brazilian-utils";
import { padEnd } from "lodash";

export const capitalize = (string) => string.charAt(0).toUpperCase() + string.slice(1);

export const getStatusText = (status) => {
    let text = "";
    switch (status) {
    case "APOLICES_VENCER": text = "Apólices a Vencer";
        break;

    case "BOLETOS_VENCIDOS": text = "Boleto Vencido";
        break;

    case "ATUALIZAR_INF": text = "Atualização de dados de tomador";
        break;

    case "PERDA_TOMADORES_NOMEADOS": text = "Perda de Tomadores Nomeados";
        break;

    case "NOMEACAO": text = "Nomeação";
        break;

    case "VENCIMENTO": text = "Vencimento";
        break;
    }

    return text;
};

export const wait = (ms) => x => new Promise(resolve => setTimeout(() => resolve(x), ms));

export const maskCep = (cep) => BRUtils.formatCEP(cep || "");

export const maskCnpj = (doc) => BRUtils.formatCNPJ(doc.replace(/[.\-\/]/g, ""));

export const maskCpf = (doc) => BRUtils.formatCPF(doc.replace(/\D/g, ""));

export const isNumberOrDash = (evt) => {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 45) {
        evt.preventDefault();
    } else {
        return true;
    }
};

export const isNumber = (evt) => {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
    } else {
        return true;
    }
};

export const isNumberOrComma = (evt) => {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 188) {
        evt.preventDefault();
    } else {
        return true;
    }
};

export const isLetter = (evt) => {
    evt = evt ? evt : window.event;

    var regex = new RegExp("^[a-zA-Z ]+$");
    var charCode = String.fromCharCode(evt.which ? evt.which : evt.keyCode);
    if (!regex.test(charCode)) {
        evt.preventDefault();
    } else {
        return true;
    }
};

export const formatDate = (date) => date.split("-").reverse().join("/");

export const formatCNPJ = (cnpj) => maskCnpj(cnpj || "");

export const formatCEP = (cep) => maskCep(cep || "");

export const formatCPF = (cpf) => maskCpf(cpf || "");

export const formatAddress = (address) => {
    if (!address)
        return;

    var formated = "";
    if (address.logradouro)
        formated = formated + address.logradouro + " - ";

    if (address.bairro)
        formated = formated + address.bairro + " - ";

    if (address.cidade)
        formated = formated + address.cidade + " - ";

    if (address.uf)
        formated = formated + address.uf + " - ";

    if (address.cep)
        formated = formated + address.cep.replace(/^(\d{5})(\d{3})/, "$1-$2");


    return formated;
};

export const isCPF = (name) => (name || "").length == 11;

export const isCNPJ = (name) => (name || "").length == 14;

export const isValidCnpj = (value) => BRUtils.isValidCNPJ(value);

export const isValidCpf = (value) => BRUtils.isValidCPF(value);

export const base64ToArrayBuffer = (base64) => {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);

    for (let i = 0; i < binaryLen; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }

    return bytes;
};

export const saveByteArray = (reportName, byte, format) => {
    let blob = new Blob([byte]);

    if (window.navigator.msSaveBlob) {
        window.navigator.msSaveOrOpenBlob(blob, reportName + "." + format);
    }
    else {
        let a = window.document.createElement("a");
        a.href = window.URL.createObjectURL(blob, { type: "text/plain" });
        a.download = reportName.trim() + "." + format;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
};

export const getMe = () => localStorage ? JSON.parse(localStorage.getItem("me")) : false;

export const isCorretor = (profileName) => (profileName || getMe().profile) === "CORRETOR";

export const isNotCorretor = (profileName) => !isCorretor(profileName);

export const toMoneyString = (value) => value.toLocaleString("pt-BR", moneyFormatOptions);

export function formatPDF(pdf, name = "documento"){
    var base64str = pdf;

    // decode base64 string, remove space for IE compatibility
    var binary = atob(base64str.replace(/\s/g, ''));
    var len = binary.length;
    var buffer = new ArrayBuffer(len);
    var view = new Uint8Array(buffer);
    for (var i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i);
    }

    // create the blob object with content-type "application/pdf"               
    var blob = new Blob( [view], { type: "application/pdf" });
    var url = URL.createObjectURL(blob);

    const link= window.document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `${name}-${new Date().toISOString().substr(0, 10)}.pdf`;
    link.click();
    window.URL.revokeObjectURL(link.href);  
}

export function formatCNPJAndCPF(cnpj_cpf){
    if(!cnpj_cpf) return 'Não possuí';

    const value = cnpj_cpf.length < 11 || cnpj_cpf.length === 11 ? 
            formatCPF(cnpj_cpf.padStart(11, '0')) 
        : 
            formatCNPJ(cnpj_cpf.padStart(14, '0'));
    
    return value;
}

export function formatCNPJAndCPFNoMask(cnpj_cpf){
    if(!cnpj_cpf) return 'Não possuí';

    const value = cnpj_cpf.length < 11 || cnpj_cpf.length === 11 ? 
            cnpj_cpf.padStart(11, '0') 
        : 
            cnpj_cpf.padStart(14, '0');
    
    return value;
}

export function addPercent(number){
    if(!number) return '-';

    const value = number+'%';

    return value;
}


// WEBPACK FOOTER //
// ./src/libs/utils.js